import { TokenBody } from '@cigna/auth/oidc-util';

export const JWT_NS = 'https://cignaforhcp.cigna.com';

export interface AccessToken extends TokenBody {
  [JWT_NS]: {
    sessionId: string;
    cn: string;
    lob: string;
    entitlements: string[];
    permissionToggles?: string[];
    operatorId?: string;
    operatorRole?: string;
    authLevel: '1' | '3' | '4'; // '1' (lowest) - user agreement, '3' - mfa pages, '4' (highest) - full auth
  };
}
